module.exports = __webpack_public_path__ + "img/4_7.1ed00add.png";